import { NKDatetimeModule } from 'ng2-datetime/ng2-datetime';
import { Component, OnInit, Input } from '@angular/core';
import { LoginService } from '../../../../services/login.service';
import { ModelService } from '../../../../services/model.service';
import { GlobalService } from '../../../../services/global.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-dashboard-export-csv',
  templateUrl: './dashboard-export-csv.component.html',
  styleUrls: ['./dashboard-export-csv.component.scss']
})
export class DashboardExportCsvComponent implements OnInit {

  @Input()
  extracted_csv: any;

  extractedInvoices: any = '';
  extractedPurchases: any = '';

  syncWithQB: boolean = false;

  datepickerFromOptions = {
    hideIcon: true,
    format: 'mm/dd/yyyy',
    placeholder: 'from'
  };
  datepickerToOptions = {
    hideIcon: true,
    format: 'mm/dd/yyyy',
    placeholder: 'to'
  };

  exportFromDate: any = '';
  exportToDate: any = '';
  _date_export_from: any = '';
  _date_export_to: any = '';
  _old_export_from: any = ''
  _old_export_to: any = '';
  _was_matched_export_from: boolean = false;
  _was_matched_export_to: boolean = false;

  disabledExportCSVButton: boolean = false;

  constructor ( 
    private model: ModelService,
    private global: GlobalService,
    public loginService: LoginService 
    ) { }

  ngOnInit() { }

  ngOnChanges() {
    if (this.extracted_csv) {
      this.extractedInvoices = this.extracted_csv.invoices || '';
      this.extractedPurchases = this.extracted_csv.purchases || '';
    }
  }

  handleDateExportFromChange ( $event ) {
    if ( $event === undefined ) return;
    let _date = ( $event.getMonth( ) + 1 ) + '/' + $event.getDate( ) + '/' + $event.getFullYear( );
    this.exportFromDate = _date;
    this._old_export_from = _date;
    this._was_matched_export_from = true;
    this.checkExportInputs( );
  }
  handleDateExportToChange ( $event ) {
    if ( $event === undefined ) return;
    let _date = ( $event.getMonth( ) + 1 ) + '/' + $event.getDate( ) + '/' + $event.getFullYear( );
    this.exportToDate = _date;
    this._old_export_to = _date;
    this._was_matched_export_to = true;
    this.checkExportInputs( );
  }


  checkExportInputs ( ) {
    let _pattern = /^(?:(?:(?:0?[13578]|1[02])(\/|-|\.)31)\1|(?:(?:0?[1,3-9]|1[0-2])(\/|-|\.)(?:29|30)\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:0?2(\/|-|\.)29\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:(?:0?[1-9])|(?:1[0-2]))(\/|-|\.)(?:0?[1-9]|1\d|2[0-8])\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;

    this.disabledExportCSVButton = false;
    if ( 
    	this.exportFromDate == '' || 
    	this.exportToDate == '' || 
    	this.exportFromDate.match( _pattern ) == null  || 
    	this.exportToDate.match( _pattern ) == null ) 
    		this.disabledExportCSVButton = true;
  }

  changeDatePickerExportFrom ( _value, _ref ) {
    _ref.exportFromDate = _value;
    _ref.checkExportInputs( );
  }
  changeDatePickerExportTo ( _value, _ref ) {
    _ref.exportToDate = _value;
    _ref.checkExportInputs( );
  }

  exportCSV ( ) {
    this.model.exportCSV( ( response ) => {
      if ( response.answer == 'success' ) {
        if ( response.info.counter == 0 ) {

          let data = {
            type: 'info',
            title: '',
            html: 'Lumigenie and Quickbooks are already is sync. CSV file will not be generated',
            showConfirmButton: true
          }
          this.global.successMessage( data );
        } else {

          let data = {
            type: 'success',
            title: 'Success',
            html: response.info.counter +' Invoices have been extracted into the CSV file: <a href="'+response.info.csv_link+'" download="'+response.info.filename+'" onClick="swal.close();">Download CSV</a>',
            showConfirmButton: false
          }
          this.global.successMessage( data );
          this.extractedInvoices = response.info.csv_link;
        }
        // setTimeout( ( ) => { 
        //   swal.close( ); 
        // }, 2500 );
      }
    });
  }

  extractPurchaseCSV ( ) {
    this.model.extractPurchaseCSV( ( response ) => {
      if ( response.answer == 'success' ) {
        if ( response.info.counter == 0 ) {

          let data = {
            type: 'info',
            title: '',
            html: 'Lumigenie and Quickbooks are already is sync. CSV file will not be generated',
            showConfirmButton: true
          }
          this.global.successMessage( data );
        } else {

          let data = {
            type: 'success',
            title: 'Success',
            html: response.info.counter +' Purchase orders have been extracted into the CSV file: <a href="'+response.info.csv_link+'" download="'+response.info.filename+'" onClick="swal.close();">Download CSV</a>',
            showConfirmButton: false
          }
          this.global.successMessage( data );
          this.extractedPurchases = response.info.csv_link;
        }
        // setTimeout( ( ) => { 
        //   swal.close( ); 
        // }, 2500 );
      }
    });
  }

  viewExtractedInvoices ( ) {
    this.global.openLinkNewTab( this.extractedInvoices );
  }

  viewExtractedPurchases ( ) {
    this.global.openLinkNewTab( this.extractedPurchases );
  }

}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/defaults/dashboard-admin/dashboard-export-csv/dashboard-export-csv.component.ts